import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const { content: c } = useContent();
  return (
    <footer data-testid="main-footer" className="bg-[#2C3520] text-[#F5F5F5]">
      <div className="container-lux py-20 md:py-28 text-center flex flex-col items-center">
        <Link to="/" className="inline-flex mb-8">
          <img src="/logo.png" alt="DonoDidio Event Management" className="h-24 md:h-28 w-auto" />
        </Link>
        <p className="font-serif-lux italic font-light text-[#EDEDE4] text-xl md:text-2xl leading-snug max-w-xl mb-14">
          {c.footer_tagline || "Your vision. Your occasion. Beautifully brought to life."}
        </p>

        <nav className="flex flex-wrap items-center justify-center gap-x-9 gap-y-4 pt-10 border-t border-white/10 w-full max-w-2xl mb-12">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[0.78rem] uppercase tracking-[0.22em] text-[#D8D8CC] hover:text-[#D4AF37] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-10 text-sm text-[#cfcfcf] mb-14">
          <a href="mailto:info.donodidioevents@gmail.com" data-testid="footer-email" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors">
            <Mail size={16} className="text-[#D4AF37]" /> info.donodidioevents@gmail.com
          </a>
          <a href="tel:+447351855327" data-testid="footer-phone" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors">
            <Phone size={16} className="text-[#D4AF37]" /> +44 7351 855327
          </a>
          <a href="https://www.instagram.com/dono_di_dioevents" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors">
            <Instagram size={16} className="text-[#D4AF37]" /> @dono_di_dioevents
          </a>
        </div>

        <div className="w-full max-w-5xl pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#7c7c7c]">
          <span>© {new Date().getFullYear()} DonoDidioevents. All rights reserved.</span>
          <Link to="/staff-login" data-testid="footer-staff-link" className="uppercase tracking-[0.2em] hover:text-[#D4AF37] transition-colors">
            Staff Login
          </Link>
        </div>

        <a
          href="https://operamind.uk/web"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-operamind-credit"
          aria-label="Powered by OperaMind Web"
          className="mt-8 inline-flex opacity-70 hover:opacity-100 transition-opacity"
        >
          <img src="/operamind-web.png" alt="Powered by OperaMind Web" className="h-7 w-auto" />
        </a>
      </div>
    </footer>
  );
}
